import React from 'react';
/////Material UI/////
import {Box, Button, Stack, Typography, useTheme} from '@mui/material';
/////Local Shared Types//////
import {LogoSize} from 'app/types/Shared';
import smallLogo from 'assets/images/header/elevateLogoSmall.svg';
import Mountains from 'assets/images/backgroundMountain.jpg';
/////React Router Dom/////
import {useNavigate} from 'react-router-dom';
///Local Components//////
import PageLayout from 'components/PageLayout/PageLayout';
import TopNavigation from 'components/TopNavigation/TopNavigation';
import {useMatomo} from '@jonkoops/matomo-tracker-react';

const NoFoundPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  // Matomo Analytics
  const {trackPageView} = useMatomo();
  React.useEffect(() => {
    trackPageView();
  });

  const header = (
    <TopNavigation authorized={false} smallLogo={smallLogo} LogoType={LogoSize.Small} banner={false} empty={true} />
  );
  const footer = <></>;

  return (
    <PageLayout header={header} footer={footer}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '99vh',
          backgroundImage: `url(${Mountains})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <Box p={8} bgcolor={theme.palette.grey[100]} border={`1px solid ${theme.palette.grey[500]}`} boxShadow={2}>
          <Stack maxWidth='sm' spacing={4} alignItems='center'>
            <Typography gutterBottom variant='h1'>
              404 - Page not found
            </Typography>
            <Typography variant='subtitle1'>We couldn&apos;t find the page you were looking for.</Typography>
            <Button variant='contained' onClick={() => navigate('/home')}>
              Back Home
            </Button>
          </Stack>
        </Box>
      </Box>
    </PageLayout>
  );
};

export default NoFoundPage;
